import {componentConfig, componentLoader} from "../../lib/component_initializer";
import {Hvid} from "./hvid";

export const hvidLoader = function (options = {}) {
    componentLoader(componentConfig(Hvid, Hvid.config.componentTypeKey, Hvid.config.baseHtmlClass), options);
};
